export default function RemoveSpace (value) {
  return value.toString().replace(/\s+/g, '');
}
